export default {
  error: (state) => state.error,
  isLoading: (state) => state.isLoading,
  progress: (state) => state.progress,
  types: (state) => state.types,
};
